export enum CpfEmailMessagesEnum {
  REQUIRED_FIELD = 'Campo obrigatório',
  INVALID_FIELD = 'Campo inválido',
}
